export const MAX_SERVICE_LOGO_MARKER_ZOOM = 10;
export const MAX_CLUSTER_ZOOM = 14;
export const MAP_DATA_REFRESH_INTERVAL = 30000;
export const MAP_DATA_REFRESH_THROTTLE_DELAY = 10000;
